import { useMemo } from 'react';

import { useAppSelector } from '../state/hooks';

export function useInpaintImgIdList({ imgId }: { imgId: number }) {
  const imgMap = useAppSelector((state) => state.image.imgMap);
  const imgElem = useAppSelector((state) => state.image.imgMap[imgId!]);
  const inpaintImgIdList = useMemo(() => {
    const list = imgElem?.inpaintImgIdList || [];
    return [...list].filter((id) => !imgMap[id]?.isSensitive && !imgMap[id]?.failed);
  }, [imgElem?.inpaintImgIdList, imgMap]);
  return inpaintImgIdList;
}
